import React, { useState } from "react";

import {
  CForm,
  CFormInput,
  CFormSelect,
  CButton,
  CRow,
  CCol,
  CFormLabel,
  CCard,
  CCardBody,
} from "@coreui/react";
import { toast } from "react-toastify";
import { visitAPI } from "src/services/api-services";
import ChartComponent from "../ChartComponent";
import PoolVisits from "../ChartComponent/PoolVisits";
import PoolVisitsByHourAndDayChart from "../ChartComponent/PoolVisitsByHourAndDayChart";
import PoolVisitsStackedChart from "../ChartComponent/PoolVisitsStackedChart";
import PoolVisitsByAmenity from "../ChartComponent/PoolVisitsByAmenity";
import PoolVisitsByAmenityStacked from "../ChartComponent/PoolVisitsByAmenityStacked";
import VisitsByAmenityAndHourChart from "../ChartComponent/VisitsByAmenityAndHourChart";
import VisitDataComponent from "../VisitDataComponent";
import VisitsByDayAmenityChart from "../VisitDataComponent/VisitsByDayAmenityChart";

const formatLocalDateTime = (date) => {
  const pad = (n) => n.toString().padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

const VisitForm = () => {
  const amenities = [
    "Clubhouse Pools or Jacuzzi",
    "Clubhouse Gym",
    "Clubhouse Raquetball Court",
    "Outdoor Pool",
  ];

  let now = new Date();

  const [formData, setFormData] = useState({
    status: "ACTIVE",
    start_datetime: formatLocalDateTime(now),
    end_datetime: formatLocalDateTime(now),
    apartment: "",
    sponsor: "",
    visitors: 1,
    amenity: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const sanitizeInput = (input) => {
    return input?.replace(/[^a-zA-Z0-9\s,.-]/g, "") || "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const sponsor = formData.sponsor.trim();

    if (sponsor.length < 3) {
      alert("Sponsor must be at least 3 characters long.");
      return;
    }

    if (!sponsor.includes(" ")) {
      alert("Sponsor must include a first and last name.");
      return;
    }

    const dataToSubmit = {
      status: sanitizeInput(formData.status),
      start_datetime: new Date(formData.start_datetime),
      end_datetime: new Date(formData.end_datetime),
      apartment: sanitizeInput(formData.apartment),
      sponsor: sanitizeInput(formData.sponsor),
      visitors: parseInt(formData.visitors),
      amenity: sanitizeInput(formData.amenity),
    };

    try {
      const result = await visitAPI.postSendVisit(dataToSubmit);
      console.log(result);

      // Play success sound
      const audio = new Audio('/success-340660.mp3');
      audio.play();

      toast.success("Thanks for your submission!");

      let now2 = new Date();

      setFormData({
        status: "ACTIVE",
        start_datetime: formatLocalDateTime(new Date()),
        end_datetime: formatLocalDateTime(new Date()),
        apartment: "",
        sponsor: "",
        visitors: 1,
        amenity: "",
      });

      location.reload();

    } catch (error) {
      console.error("Submission error:", error);
      toast.error("There was a problem submitting the form.");
    }
  };

  // Custom styles for compact and inline label/input layout
  const rowStyle = {
    alignItems: "center",
    marginBottom: "0.8rem",
  };

  const labelColProps = {
    xs: 12,
    sm: 4,
    md: 3,
    style: { paddingRight: "0.5rem", fontWeight: "600", whiteSpace: "nowrap" },
  };

  const inputColProps = {
    xs: 12,
    sm: 8,
    md: 9,
  };

  const clickToOpen = () => {
    alert("This will be a temporary delete capability");
    const newWindow = window.open("/#/visit?DELETE=true");
    setTimeout(() => {
      if (newWindow) {
        newWindow.close(); // Close the new window
      }
      window.location = "/#/visit"; // Redirect the current window
      window.location.reload();
    }, 1500);
  };

  return (
    <>
      <CRow>
        <CCol>
          <VisitsByDayAmenityChart />
          {/* <button onClick={clickToOpen}>Delete Records</button> */}
        </CCol>
        <CCol>


          {/* <VisitDataComponent /> */}
          <h1 style={{ marginBottom: "1rem", textAlign: "center" }}>Summerwood Apartments</h1>
          <CCard className="mx-auto" style={{ maxWidth: "600px" }}>
            <CCardBody>
              <CForm onSubmit={handleSubmit}>
                <input type="hidden" name="status" value={formData.status} />

                {/* Start Date/Time */}
                <CRow style={rowStyle}>
                  <CCol {...labelColProps} style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <CFormLabel htmlFor="start_datetime" style={{ whiteSpace: "normal" }}>
                      <div>Visit Date/Time</div>
                      <div style={{ fontSize: "0.8em", color: "#555" }}>Fecha y hora de visita</div>
                    </CFormLabel>
                  </CCol>
                  <CCol {...inputColProps}>
                    <CFormInput
                      id="start_datetime"
                      type="datetime-local"
                      name="start_datetime"
                      value={formData.start_datetime}
                      onChange={handleChange}
                      required
                      size="sm"
                      style={{ height: "34px" }}
                    />
                  </CCol>
                </CRow>

                {/* End Date/Time (hidden/disabled) */}
                <CRow style={{ ...rowStyle }}>
                  <CCol {...labelColProps}>
                    {/* <CFormLabel htmlFor="end_datetime">End Date/Time</CFormLabel> */}
                  </CCol>
                  <CCol {...inputColProps}>
                    <CFormInput
                      id="end_datetime"
                      type="datetime-local"
                      name="end_datetime"
                      value={formData.end_datetime}
                      onChange={handleChange}
                      required
                      size="sm"
                      style={{ display: "none", height: "34px" }}
                    />
                  </CCol>
                </CRow>

                {/* Apartment */}
                <CRow style={rowStyle}>
                  <CCol {...labelColProps} style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <CFormLabel htmlFor="apartment" style={{ whiteSpace: "normal" }}>
                      <div>Apartment</div>
                      <div style={{ fontSize: "0.8em", color: "#555" }}>Apartamento</div>
                    </CFormLabel>
                  </CCol>
                  <CCol {...inputColProps}>
                    <CFormInput
                      id="apartment"
                      placeholder="40N20"
                      minLength={3}
                      type="text"
                      name="apartment"
                      value={formData.apartment}
                      onChange={handleChange}
                      autoComplete="off"
                      required
                      pattern="^\d+[a-zA-Z]+\d+$"
                      title="Must be in the format: digits, letters, then digits (e.g., 40N20)"
                      size="sm"
                      style={{ height: "34px" }}
                    />
                  </CCol>
                </CRow>

                {/* Sponsor */}
                <CRow style={rowStyle}>
                  <CCol {...labelColProps} style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <CFormLabel htmlFor="sponsor" style={{ whiteSpace: "normal" }}>
                      <div>Sponsor</div>
                      <div style={{ fontSize: "0.8em", color: "#555" }}>Patrocinador</div>
                    </CFormLabel>
                  </CCol>
                  <CCol {...inputColProps}>
                    <CFormInput
                      id="sponsor"
                      placeholder="Firstname Lastname"
                      minLength={3}
                      type="text"
                      name="sponsor"
                      pattern=".* .+"
                      title="Please enter both first and last name"
                      value={formData.sponsor}
                      onChange={handleChange}
                      autoComplete="off"
                      required
                      size="sm"
                      style={{ height: "34px" }}
                    />
                  </CCol>
                </CRow>

                {/* Number of Visitors */}
                <CRow style={rowStyle}>
                  <CCol {...labelColProps} style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <CFormLabel htmlFor="visitors" style={{ whiteSpace: "normal" }}>
                      <div>Number of Visitors</div>
                      <div style={{ fontSize: "0.8em", color: "#555" }}>Número de visitantes</div>
                    </CFormLabel>
                  </CCol>
                  <CCol {...inputColProps}>
                    <CFormInput
                      id="visitors"
                      type="number"
                      name="visitors"
                      min="1"
                      value={formData.visitors}
                      onChange={handleChange}
                      required
                      size="sm"
                      style={{ height: "34px" }}
                    />
                  </CCol>
                </CRow>

                {/* Amenity */}
                <CRow style={{ ...rowStyle, marginBottom: "1.2rem" }}>
                  <CCol {...labelColProps} style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <CFormLabel htmlFor="amenity" style={{ whiteSpace: "normal" }}>
                      <div>Amenity</div>
                      <div style={{ fontSize: "0.8em", color: "#555" }}>Amenidad</div>
                    </CFormLabel>
                  </CCol>
                  <CCol {...inputColProps}>
                    <CFormSelect
                      id="amenity"
                      name="amenity"
                      value={formData.amenity}
                      onChange={handleChange}
                      required
                      size="sm"
                      style={{ height: "34px" }}
                    >
                      <option value="">Choose One / Elija uno</option>
                      {amenities.map((amenity, index) => (
                        <option
                          key={index}
                          value={amenity.toLowerCase().replace(/ /g, "-")}
                        >
                          {amenity}
                        </option>
                      ))}
                    </CFormSelect>
                  </CCol>
                </CRow>
                <CRow><CCol><hr></hr></CCol></CRow>
                <CButton color="success" type="submit" className="w-100" size="sm">
                  Submit Amenity Sign-In / Enviar registro de amenidad
                </CButton>
              </CForm>

            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      {/* <PoolVisitsByAmenityStacked />
      <PoolVisitsByAmenity />
      <PoolVisitsStackedChart />
      <PoolVisitsByHourAndDayChart />
      <PoolVisitsByHourAndDayChart />
      <ChartComponent />
      <PoolVisits /> */}
    </>
  );
};

export default VisitForm;
